import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './core/helpers/loader.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { GaService } from './core/helpers/ga.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LocalizationService } from './core/helpers/localization.service';
import { environment } from 'src/environments/environment';
import { CoreService } from 'src/app/core/helpers/core.service';
import { BrowserDetectionService } from './services/browser-detection.service';

@Component({
  selector: 'loyaltic-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
  
export class AppComponent implements OnInit {
  title = 'loyaltic';
  isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  public loading = false;
  currentLang = 'en';
  showLocalizationPopup = false;
  isLiveUrl = false;
  date = new Date();
  isComingSoon = false;
  lockview = false;
  isCampaignEnded = false;
  cookieScriptUrl = '';
  isAppBrowser = false;
  isGeoRestricted = false;
  geoRestrictionMessage = 'This service is unavailable in your current location.';
  isCashbackRoute = false;

  
  @ViewChild('localizationPopup', { static: false }) localizationPopupRef: any;
  public modalRef: BsModalRef;

  popupConfig = {
    ignoreBackdropClick: true,
    class: 'win modal-md modal-dialog-left',
  };

  showSettingIcon = false;

  constructor(
    public translate: TranslateService,
    private loader: LoaderService,
    private router: Router,
    private browserDetectionService: BrowserDetectionService,
    public gaService: GaService,
    private modalService: BsModalService,
    private coreService: CoreService,
    private localizationService: LocalizationService,
    private activatedRoute: ActivatedRoute
  ) {
    this.updateAllowedComingSoonRoute();
    this.checkComingSoon();
    translate.setDefaultLang('fi-FI');
  
  }

  ngOnInit(): void {
    this.addGaScript();

    this.translate.get('cookie-script').subscribe((translatedString) => {
      this.cookieScriptUrl = translatedString;
      if (this.cookieScriptUrl.includes('src'))
      this.loadCookieScript(this.cookieScriptUrl);
    }, error => {
      console.log(error);
    });

    this.loader.getInputChangeLoaderEmitter().subscribe((res: any) => {
      this.loading = res;
    });

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        this.updateAllowedComingSoonRoute();
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
      }
    });

    // Check if opened inside an in-app browser and redirect
    this.isAppBrowser = this.browserDetectionService.isInAppBrowser();
    if (this.isAppBrowser) {
      document.body.classList.add('body-in-app');
      //window.location.href = "https://nosynpro25.azurewebsites.net/"; // Redirect to external browser
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('body-in-app');
  }


  openAppsLink(url: string): void {
    window.open(url, '_blank');
  }

  loadCookieScript(cookieScript: string) {
    let dynamicScript = document.createElement("script");
    dynamicScript.type = "text/javascript";
    dynamicScript.charset = 'UTF-8';

    var doc = new DOMParser().parseFromString(cookieScript, "text/html");
    let src = doc.scripts[0].getAttribute('src');

    dynamicScript.src = src;
    document.body.appendChild(dynamicScript);
  }

  addGaScript() {
    this.translate.get('ga-script-id').subscribe((translatedString: string) => {
      let dynamicScript = document.createElement("script");
      dynamicScript.async = true;
      dynamicScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + translatedString;
      document.head.appendChild(dynamicScript);

      let tagScript = document.createElement("script");
      tagScript.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${translatedString}');`;
      document.head.appendChild(tagScript);
    }, error => {
      console.log(error);
    });
  }
  
  private showIOSInstructions(url: string): void {
    // Display a prompt with instructions to copy the URL
    const message = `Please tap the menu (•••) at the bottom and select "Open in Safari" to play the game.`;
    alert(message);
    // Optionally, copy the URL to clipboard
    navigator.clipboard.writeText(url).then(() => {
      alert('URL copied to clipboard. Paste it into Safari.');
    }).catch(() => {
      // Fallback if clipboard access is denied
      prompt('Copy this URL:', url);
    });
  }
  async checkComingSoon() {
    const hostname = window.location.hostname;

    await this.coreService.getLiveConfig().then((response: any) => {
      const goLiveDateString = response.result.liveDate;
      const goLiveDate = new Date(goLiveDateString);

      const campaignEndDateString = response.result.campaignEndDate;
      const campaignLiveDate = new Date(campaignEndDateString);

      response.result.liveUrls.forEach(element => {
        if (hostname.toLowerCase().indexOf(element) != -1) {
          this.isLiveUrl = true;
        }
      });

      if (goLiveDate > this.date && this.isLiveUrl) {
        this.lockview = false;
        this.isComingSoon = true;
        this.isCampaignEnded = false;
      } else if (campaignLiveDate < this.date && this.isLiveUrl) {
        this.isComingSoon = false;
        this.lockview = false;
        this.isCampaignEnded = true;
      } else {
        this.lockview = false;
        this.isComingSoon = false;
        this.isCampaignEnded = false;
      }
    }).catch((error) => {
      // Handle geo-restriction error
      if (error.status === 403 && error.error.message === 'This service is only available from Finland.') {
        console.log('Geo-restriction detected');
        this.isGeoRestricted = true;
        this.lockview = false;
        this.isComingSoon = false;
      } else {
        console.error('Error fetching live config:', error);
      }
    });
  }

  private updateAllowedComingSoonRoute() {
    this.isCashbackRoute = window.location.pathname.toLowerCase().startsWith('/cashback');
  }

  showLocalizations() {
    this.showLocalizationPopup = true;
    this.modalRef = this.modalService.show(this.localizationPopupRef, this.popupConfig);
  }
}
